module.exports = __webpack_public_path__ + "static/media/AB_lock_grey.9060b63d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_lock_grey.svg
// module id = 263
// module chunks = 0